// Commercial partner / regional distributor detection (Sep 2026 policy).
// Distributors in-license by territory, not TA: personal stated-interest tags
// and specialist routing never hide their contacts — everyone is reachable.
const ROLE_RE = /commercial_partner|regional_commercializ|regional_distributor|distributor/i;
const TEXT_RE = /distributor|commercial/i;

export const isCommercialPartnerTarget = (tc, profile) => {
  if (!tc && !profile) return false;
  if (tc?.source === 'commercial_partner') return true;
  if (ROLE_RE.test(`${tc?.target_role || ''} ${tc?.outreach_bucket || ''}`)) return true;
  if (TEXT_RE.test(`${tc?.fit_category || ''} ${tc?.buyer_archetype || ''}`)) return true;
  return TEXT_RE.test(`${profile?.category || ''} ${profile?.company_type || ''} ${profile?.licensing_category || ''}`);
};
